import { z } from 'zod';
/**
 * «Экспедиция» через HTTP API: контент глав и уровней, попытки уровней и прогресс
 * (SPEC.md, разделы 5.3, 15.4, 17.3).
 */
/** Сосуды (совпадают с VESSEL_IDS из game-core; проверяется тестом сервера). */
export const VESSEL_IDS = ['jar', 'tube', 'petri', 'flask', 'bioreactor'];
/** Способности соло (SPEC.md, 15.2): слот C — Криотерапия или Антибиотик. */
export const SOLO_ABILITIES = ['cryo', 'antibiotic'];
export const LEVEL_ID_PATTERN = /^[1-9]-[1-9]$/;
export const createAttemptSchema = z.strictObject({
    levelId: z.string().regex(LEVEL_ID_PATTERN),
    /** Обязательна, если уровень предлагает способности. */
    ability: z.enum(SOLO_ABILITIES).optional(),
});
/**
 * Журнал команд партии: один символ на команду, в порядке применения.
 * В журнал попадают только команды, которые движок принял.
 */
export const COMMAND_CODES = {
    tick: 't',
    'move-left': 'l',
    'move-right': 'r',
    'rotate-clockwise': 'c',
    'rotate-counterclockwise': 'w',
    'soft-drop': 's',
    'hard-drop': 'h',
    /** use-ability { slot: 0 } — в соло один слот. */
    'use-ability': 'a',
};
/** Самая длинная допустимая партия (символов журнала). */
export const MAX_JOURNAL_LENGTH = 200_000;
export const submitAttemptSchema = z.strictObject({
    journal: z
        .string()
        .max(MAX_JOURNAL_LENGTH)
        .regex(/^[tlrcwsha]*$/),
});
//# sourceMappingURL=expedition.js.map